import React, { useContext } from 'react';

import BuildingContext from '@totem/components/portfolio/buildings/details/container/BuildingContext';
import addressUtilities from '@totem/utilities/addressUtilities';
import { isNotNull } from '@totem/utilities/common';

const BuildingDetailPageSubTitle = () => {
  const { data } = useContext(BuildingContext);

  if (!isNotNull(data)) {
    return <span />;
  }

  const address = addressUtilities.getAddress(data.building);
  const regionName = data.region?.name;

  const subtitle = [regionName, address].filter(Boolean).join(' / ');

  return <span>{subtitle}</span>;
};

export default BuildingDetailPageSubTitle;
